<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择翻车机作业记录" :visible.sync="visible">
    <div>
      <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate" @row-save="rowSave"
        @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @row-dblclick="rowDblClick"
        @on-load="onLoad">
      </avue-crud>
    </div>
  </dialog-reset>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getWagonTipplerOperationRecordPage } from "../api";

export default {
  mixins: [crudMixins],
  name: 'SelectWagonTipplerOperationRecordList',
  data () {
    return {
      apiConfig: { getList: getWagonTipplerOperationRecordPage },
      defaultParams: {},
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
          {
            label: '作业编号',
            prop: 'operationNo',
            search: true,
          },
          {
            label: '设备编码',
            prop: 'deviceCode',
            search: true,
          },
          {
            label: '作业日期',
            prop: 'operationDate',
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            search: true,
          },
          {
            label: '开始时间',
            prop: 'startTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            format: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '结束时间',
            prop: 'endTime',
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            format: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '总耗时(秒)',
            prop: 'totalSeconds',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '作业状态',
            prop: 'operationStatus',
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=operation_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择作业状态', trigger: 'change'}
            ],
          },
          {
            label: '翻卸车数',
            prop: 'vehicleCount',
          },
          {
            label: '数据来源协议',
            prop: 'dataSource',
          },
          {
            label: '备注描述',
            prop: 'remark',
            type: 'textarea',
          },
        ],
      },
    }
  },
  created () { },
  methods: {
    open () {
      this.visible = true
    },
    // 双击行选择
    rowDblClick (item) {
      this.$emit('replace', item)
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>
